import * as angular from 'angular';
import * as policiesPolicyCard from './policies-policy-card';
import * as policiesPolicyHistoryCard from './policies-policy-history-card';
import * as policiesHistorySection from './policies-history-section';

const module = angular.module('policies-page-components', [
    policiesPolicyCard.module.name,
    policiesHistorySection.module.name,
    policiesPolicyHistoryCard.module.name
]);

export { module };
